import React from 'react';
import PropTypes from 'prop-types';
import { Update, Done, RemoveCircle, Block, MoodBad, Refresh, Event } from '@material-ui/icons';


const iconMap = {
    update: Update,
    done: Done,
    remove_circle: RemoveCircle,
    block: Block,
    mood_bad: MoodBad,
    refresh: Refresh,
    earring: Event
};

const DynamicIcon = ({ iconName }) => {
    const IconComponent = iconMap[iconName] || Update; // Obtén el componente o el ícono predeterminado
    return <IconComponent />; // Renderiza el componente ícono
};

DynamicIcon.propTypes = {
    iconName: PropTypes.string.isRequired,
};

export default DynamicIcon;
